export * from './mitarbeiter-aktualisiert.interface';
